<template>
  <section class="anchor about-drug" :id="$t('header.nav[1].link')">
    <div class="container">
      <h2 class="about-drug__title" v-html="$t('home.aboutDrug.title')"></h2>
      <h6
        class="about-drug__subtitle"
        v-html="$t('home.aboutDrug.subtitle')"
      ></h6>
      <div class="about-drug__list">
        <div
          class="about-drug__list-title"
          v-html="$t('home.aboutDrug.howWork.title')"
        ></div>
        <div class="about-drug__list-row">
          <div class="about-drug__list-col">
            <div
              class="about-drug__list-item about-drug__list-item--1"
              v-html="$t('home.aboutDrug.howWork.item_1')"
            ></div>
          </div>
          <div class="about-drug__list-col">
            <div
              class="about-drug__list-item about-drug__list-item--2"
              v-html="$t('home.aboutDrug.howWork.item_2')"
            ></div>
          </div>
          <div class="about-drug__list-col">
            <div
              class="about-drug__list-item about-drug__list-item--3"
              v-html="$t('home.aboutDrug.howWork.item_3')"
            ></div>
          </div>
          <div class="about-drug__list-col">
            <div
              class="about-drug__list-item about-drug__list-item--4"
              v-html="$t('home.aboutDrug.howWork.item_4')"
            ></div>
          </div>
        </div>
      </div>
      <div class="about-drug__description">
        <p v-html="$t('home.aboutDrug.description.item_1')"></p>
        <p v-html="$t('home.aboutDrug.description.item_2')"></p>
      </div>
      <div class="about-drug__footer">
        <div class="about-drug__footer-row">
          <div class="about-drug__footer-col-left">
            <router-link
              @click.native="mainMaDrug()"
              :to="$t('home.aboutDrug.button.link')"
              class="about-drug__footer-btn"
            >
              {{ $t("home.aboutDrug.button.title") }}
            </router-link>
          </div>
          <div class="about-drug__footer-col-right">
            <div
              class="about-drug__footer-info"
              v-html="$t('home.aboutDrug.buttonInfo')"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutDrug",
  methods: {
    mainMaDrug() {
      // eslint-disable-next-line no-undef
      gtag("event", "click", { event_category: "main_ma_drug" });
    }
  }
};
</script>
